import React from "react";
import "./Skill.css";
import Fade from "react-reveal/Fade";
import html from "../images/html.svg";
import css from "../images/css-3.svg";
import bootstrap from "../images/bootstrap-5-1.svg";
import tailwind from "../images/tailwind-css-2.svg";
import js from "../images/logo-javascript.svg";
import material from "../images/material-ui-1.svg";
import react from "../images/react-2.svg";
import reactnative from "../images/react-native-1.svg";
import node from "../images/nodejs-icon-logo-svgrepo-com.svg";
import java from "../images/java-icon.svg";
import mongo from "../images/mongodb-icon-1.svg";
import sql from "../images/mysql-6.svg";
import typescript from "../images/typescript.svg";
import npm from "../images/npm-square-red-1.svg";
import heroku from "../images/heroku-4.svg";
import firebase from "../images/firebase-1.svg";
import netlify from "../images/netlify.svg";
import stripe from "../images/stripe-4.svg";

const Skill = () => {
  return (
    <div className="skill" id="skills">
      <h2 className="font-heading pt-3 mt-3 text-center">
        <span className="about-title ">Skills</span>
      </h2>
      <div className="container my-5">
        <div className="row mt-5">
          <Fade left>
            <div className="col-lg-2 col-4 my-4">
              <div class="card font">
                <img src={html} alt="..." className="my-3" />
                <div class="card-body my-2">
                  <p>HTML 5</p>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-4 my-4">
              <div class="card font">
                <img src={css} alt="..." className="my-3" />
                <div class="card-body my-2">
                  <p>CSS 3</p>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-4 my-4">
              <div class="card font">
                <img src={bootstrap} alt="..." className="my-3" />
                <div class="card-body my-2">
                  <p>Bootstrap 5</p>
                </div>
              </div>
            </div>
          </Fade>
          <Fade right>
            <div className="col-lg-2 col-4 my-4">
              <div class="card font">
                <img src={tailwind} alt="..." className="my-3" />
                <div class="card-body my-2">
                  <p>Tailwind CSS</p>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-4 my-4">
              <div class="card font">
                <img src={material} alt="..." className="my-3" />
                <div class="card-body my-2">
                  <p>Material UI</p>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-4 my-4">
              <div class="card font">
                <img src={js} alt="..." className="my-3" />
                <div class="card-body my-2">
                  <p>JavaScript</p>
                </div>
              </div>
            </div>
          </Fade>
        </div>
        <div className="row mb-2">
          <Fade left>
            <div className="col-lg-2 col-4 my-4">
              <div class="card font">
                <img src={react} alt="..." className="my-3" />
                <div class="card-body my-2">
                  <p>React JS</p>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-4 my-4">
              <div class="card font">
                <img src={reactnative} alt="..." className="my-3" />
                <div class="card-body my-2">
                  <p>React Native</p>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-4 my-4">
              <div class="card font">
                <img src={node} alt="..." className="my-3" />
                <div class="card-body my-2">
                  <p>Node JS</p>
                </div>
              </div>
            </div>
          </Fade>
          <Fade right>
            <div className="col-lg-2 col-4 my-4">
              <div class="card font">
                <img src={java} alt="..." className="my-3" />
                <div class="card-body my-2">
                  <p>Java</p>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-4 my-4">
              <div class="card font">
                <img src={mongo} alt="..." className="my-3" />
                <div class="card-body my-2">
                  <p>MongoDB</p>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-4 my-4">
              <div class="card font">
                <img src={sql} alt="..." className="my-3" />
                <div class="card-body my-2">
                  <p>MySQL</p>
                </div>
              </div>
            </div>
          </Fade>
        </div>
        {/* <div className="row mb-2">
          <Fade left>
            <div className="col-lg-2 col-4 my-4">
              <div class="card font">
                <img src={npm} alt="..." className="my-3" />
                <div class="card-body my-2">
                  <p>NPM</p>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-4 my-4">
              <div class="card font">
                <img src={heroku} alt="..." className="my-3" />
                <div class="card-body my-2">
                  <p>Heroku</p>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-4 my-4">
              <div class="card font">
                <img src={firebase} alt="..." className="my-3" />
                <div class="card-body my-2">
                  <p>Firebase</p>
                </div>
              </div>
            </div>
          </Fade>
          <Fade right>
            <div className="col-lg-2 col-4 my-4">
              <div class="card font">
                <img src={netlify} alt="..." className="my-3" />
                <div class="card-body my-2">
                  <p>Netlify</p>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-4 my-4">
              <div class="card font">
                <img src={stripe} alt="..." className="my-3" />
                <div class="card-body my-2">
                  <p>Stripe JS</p>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-4 my-4">
              <div class="card font">
                <img src={typescript} alt="..." className="my-3" />
                <div class="card-body my-2">
                  <p>TypeScript</p>
                </div>
              </div>
            </div>
          </Fade>
        </div> */}
      </div>
    </div>
  );
};

export default Skill;
